var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleMugIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.506,
    height: 49.506,
    viewBox: "0 0 49.506 49.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "all_elements_icons_48px_cup",
    "data-name": "all / elements / icons / 48px cup",
    transform: "translate(0.753 0.753)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3918",
    "data-name": "Group 3918",
    transform: "translate(-642.188 -244.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M674.129,261.036H657.013V277.86a3.637,3.637,0,0,0,3.668,3.605h9.781a3.637,3.637,0,0,0,3.667-3.605Z",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M663.68,261.036v6.073m-2.761,1.243,1.243-1.243h2.484l1.243,1.243v3.727h-4.97Z",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M674.129,265.524h2.415a2.414,2.414,0,0,1,2.415,2.414v4.83a2.415,2.415,0,0,1-2.415,2.415h-2.415",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M660.861,253.858c-1.877,1.385,1.947,3.534,0,4.969",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M665.554,253.858c-1.877,1.385,1.947,3.534,0,4.969",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M670.247,253.858c-1.877,1.385,1.947,3.534,0,4.969",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleMugIcon);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };